exports.components = {
  "component---src-templates-error-page-js": () => import("./../../../src/templates/errorPage.js" /* webpackChunkName: "component---src-templates-error-page-js" */),
  "component---src-templates-home-js": () => import("./../../../src/templates/home.js" /* webpackChunkName: "component---src-templates-home-js" */)
}

